<template>
  <div class="wrapper add-lang">
    <b-modal
      id="modal"
      v-model="isOpen"
      header-bg-variant="light"
      footer-bg-variant="light"
      :title="$t('pages.user-cv.my-recommendations.modal.title', 'Edit my recommendations')"
      :hide-footer="addNew"
      :ok-title="$t('generic.ok', 'OK')"
      ok-only
      @hidden="$emit('closeModal'); addNew = false;"
    >
      <div class="d-flex justify-content-between">
        <strong style="font-size: 1rem;">{{ $t('pages.user-cv.my-recommendations.modal.your-recommendations', 'Your recommendations') }}</strong>
        <b-button
          v-if="!addNew"
          size="sm"
          variant="success"
          @click="addRecommendation()"
        >
          {{ $t('generic.add-new', 'Add new') }}
        </b-button>
      </div>
      <hr>
      <div v-if="!addNew">
        <div v-if="!recommendations">
          {{ $t('pages.user-cv.my-recommendations.modal.no-recommendations', 'No recommendations yet!') }}
        </div>
        <div
          v-for="recommendation in recommendations"
          :key="recommendation.id"
          class="mb-4"
        >
          <div class="row">
            <div class="col-12 col-md-9">
              <div class="mb-0">
                <span class="input-label">
                  {{ $t('inputs.first-name.title') }}:
                </span>
                <span style="font-size: 1rem !important; text-transform: uppercase">
                  {{ recommendation.name }}
                </span>
              </div>
              <div>
                <span class="input-label">
                  {{ $t('inputs.email.title') }}:
                </span>
                <span class="input-text">
                  {{ recommendation.email }}
                </span>
              </div>
              <div>
                <span class="input-label">
                  {{ $t('inputs.phone.title') }}:
                </span>
                <span class="input-text">
                  {{ recommendation.phone }}
                </span>
              </div>
              <div>
                <span class="input-label">
                  {{ $t('pages.user-cv.my-recommendations.text', 'Text') }}:
                </span>
                <span class="input-text">
                  {{ recommendation.text }}
                </span>
              </div>
            </div>
            <div class="col-12 col-md-3 my-auto">
              <b-button
                variant="outline-danger"
                size="sm"
                @click="remove(recommendation.id)"
              >
                {{ $t('generic.delete', 'Delete') }}
              </b-button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="addNew">
        <div
          class="go-back mb-2"
          @click="resetOnBack()"
        >
          <font-awesome-icon icon="arrow-left" /> {{ $t('generic.back', 'Back') }}
        </div>
        <div class="mb-3">
          <label for="name">{{ $t('pages.user-cv.my-recommendations.name', 'Name') }}</label>
          <b-form-input
            id="name"
            v-model="$v.form.name.$model"
            :state="$v.form.name.$dirty ? !$v.form.name.$error : null"
          />
        </div>
        <div class="row mb-3">
          <div class="col">
            <label for="phone">{{ $t('pages.user-cv.my-recommendations.phone', 'Phone') }}</label>
            <b-form-input
              id="phone"
              v-model="$v.form.phone.$model"
              :state="$v.form.phone.$dirty ? !$v.form.phone.$error : null"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col">
            <label for="email">{{ $t('pages.user-cv.my-recommendations.email', 'Email') }}</label>
            <b-form-input
              id="email"
              v-model="$v.form.email.$model"
              :state="$v.form.email.$dirty ? !$v.form.email.$error : null"
            />
          </div>
        </div>
        <div>
          <label for="text">
            {{ $t('pages.user-cv.my-recommendations.text', 'Text') }}
            <span class="grey">({{ $t('generic.optional', 'optional') }})</span>
          </label>
          <b-form-textarea
            id="text"
            v-model="form.text"
            rows="5"
            :state="textLength <= 200"
          />
          <div class="grey">
            {{ textLength }}/200
          </div>
        </div>
        <b-button
          variant="success"
          class="mt-3 float-right"
          :disabled="!readyToSave"
          @click="saveNew"
        >
          {{ $t('generic.save', 'Save') }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";

export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    recommendations: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      addNew: false,
      form: {
        name: "",
        phone: "",
        email: "",
        text: "",
      }
    }
  },
  validations: {
    form: {
      name: { required },
      email: { required, email },
      phone: { required }
    }
  },
  computed: {
    textLength() {
        return this.form.text ? this.form.text.length : 0;
    },
    readyToSave() {
      return (this.textLength < 200 && !this.$v.$invalid);
    }
  },
  methods: {
    addRecommendation() {
      this.addNew = true;
    },
    resetOnBack() {
      this.addNew = false;
      this.form.name = "";
      this.form.phone = "";
      this.form.email = "";
      this.form.text = "";
    },
    saveNew() {
      let elementId;
      if(this.recommendations && this.recommendations.length) {
        elementId = this.recommendations[this.recommendations.length-1].id + 1;
      } else {
        elementId = 1;
      }
      let recommendation = {
        id: elementId,
        name: this.form.name,
        phone: this.form.phone,
        email: this.form.email,
        text: this.form.text
      };
      this.axios.put('/cv/update/recommendations', { recommendation: recommendation })
        .then(response => this.$emit('updateCv', response.data))
        .catch();

      this.addNew = false;
    },
    remove(recommendationId) {
      this.axios.delete('/cv/delete/recommendations/' + recommendationId)
        .then( response => this.$emit('updateCv', response.data))
        .catch();
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
  .add-lang {
    font-size: 0.9rem;
  }

 .modal-title {
    font-weight: 600 !important;
  }

  label {
    margin-bottom: 0;
  }

  .grey {
    color: #999;
  }

  .input-label {
    font-size: 0.8rem;
  }

  .input-text {
    font-size: 0.9rem;
    color: rgb(100, 100, 100);
  }
</style>

